import { t } from "@/i18n";

import type { DenetimBulguRow } from "./rows";
import { SIDDET_LABEL_KEY, TUR_LABEL_KEY } from "./severity";

const CSV_BASLIK = ["Tur", "Urun_Kart_ID", "Urun_Adi", "Kategori", "Stok", "Siddet", "Mevcut_Ozellik", "Kanit"];

function csvHucre(v: unknown): string {
  return `"${String(v ?? "").replace(/"/g, '""')}"`;
}

/**
 * Saf CSV metni uretici (indirme yan etkisi YOK — test edilebilir). Eski
 * frontend/public/js/denetim.js `csvIndir()` ile ayni sutunlar/ayrac (`;`,
 * TR Excel icin) + BOM'suz govde (BOM `triggerCsvDownload`'ta eklenir).
 */
export function buildDenetimCsv(rows: DenetimBulguRow[]): string {
  const satirlar = [
    CSV_BASLIK,
    ...rows.map((r) => [
      t(TUR_LABEL_KEY[r.tur]),
      r.urun_kart_id ?? "",
      r.ad ?? "",
      r.kategori ?? "",
      r.stok ?? "",
      t(SIDDET_LABEL_KEY[r.siddet]),
      r.mevcut_ozellik_degeri ?? t("denetim.tanimsiz"),
      (r.kanit || "").replace(/[\r\n;]+/g, " ").slice(0, 200),
    ]),
  ];
  return satirlar.map((satir) => satir.map(csvHucre).join(";")).join("\r\n");
}

/** Tarayicida indirme yan etkisi — BOM'lu blob + gecici <a>. */
export function triggerCsvDownload(csv: string, filename: string): void {
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" }); // UTF-8 BOM (Excel)
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function denetimCsvDosyaAdi(): string {
  const bugun = new Date().toISOString().slice(0, 10);
  return `katalog-denetimi-${bugun}.csv`;
}
